import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetFaq } from '@/query/queries/common/useGetFaq';
import { useGetMe } from '@/hooks/useGetMe';
import { AccordionItem } from '@scramble/ui';
import { parseWithLinks } from '@/helpers/utils';
import s from './index.module.scss';

export const MiniFaqs = ({ source, params, disabled, children }) => {
  const { t } = useTranslation();
  const { data: pageQuestions } = useGetFaq(
    { page: source, ...params },
    !disabled || !source,
  );
  const { isSuspended } = useGetMe();

  if (!pageQuestions || isSuspended || !pageQuestions.faqs.length) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <h4 className={s.title}>{t('containers:mini_faq.title')}</h4>
      {children}
      <div className={s.list}>
        {pageQuestions.faqs.map(item => {
          const parsedText = parseWithLinks(item.faq.answer);
          return (
            <AccordionItem
              key={item.id}
              title={item.faq.question}
              closeOnOutsideClick={false}
            >
              <div className={classnames('unreset', s.text)}>{parsedText}</div>
            </AccordionItem>
          );
        })}
      </div>
    </div>
  );
};
